import { useEffect, useState } from "react";

import { ArrowIcon, Wrapper } from "./ToTopButton.styled";

const ToTopButton = () => {
  const [showToTopButton, setShowToTopButton] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 350) {
      setShowToTopButton(true);
    } else {
      setShowToTopButton(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    showToTopButton && (
      <Wrapper onClick={handleScrollToTop}>
        <ArrowIcon src="/assets/svg/toTopArrow.svg" alt="To top button" />
      </Wrapper>
    )
  );
};

export default ToTopButton;
